module.exports = __webpack_public_path__ + "img/sinergi-daur-ulang.b0bbf991.png";